$(document).on("shopify:section:load", function () {
	$(".faces-slider.owl-loaded").trigger("destroy.owl.carousel")
	$(".faces-slider:not(.owl-loaded)").slick({
		infinite: false,
		dots: false,
		arrows: true,
		fade: true,
		prevArrow: '<button type="button" class="slick-prev"><</button>',
		nextArrow: '<button type="button" class="slick-next">></button>',
	})
})

$(window).on("load", function () {
	$(".main__content").css("padding-top", $("#header").outerHeight())
})

const productForm = document.querySelector(".product-form")
const observer = new MutationObserver((mutationRecords) => {
	// console.log(mutationRecords)
	if ($(".product-form").find(".swatchProductColor").data("handle") !== undefined) {
		$(".swatchProductColor").each(function () {
			const that = $(this)
			const handle = that.data("handle")
			fetch(`/products/${handle}.js`, {
				headers: {
					"Content-Type": "application/json",
				},
			})
				.then(function (response) {
					if (!response.ok) {
						throw response
					}
					const json = response.json()
					return json
				})
				.then(function (product) {
					if (product.available == false) {
						$(that).addClass("unavailable")
					}
				})
				.catch((error) => console.error("Product error", error))
		})
	}
})

if (productForm) {
	observer.observe(productForm, {
		childList: true,
	})
}

// $("body").on("DOMSubtreeModified", ".product-details-wrap", function () {
// 	// console.log("test");
// 	// infinite loop
// 	// if ($(this).find(".swatchProductColor").data("handle") !== undefined) {
// 	// 	$(".swatchProductColor").each(function () {
// 	// 		const that = $(this)
// 	// 		const handle = that.data("handle")
// 	// 		fetch(`/products/${handle}.js`, {
// 	// 			headers: {
// 	// 				"Content-Type": "application/json",
// 	// 			},
// 	// 		})
// 	// 			.then(function(response) {
// 	// 				if (!response.ok) {
// 	// 					throw response
// 	// 				}
// 	// 				const json = response.json()
// 	// 				return json
// 	// 			})
// 	// 			.then(function (product) {
// 	// 				// console.log(product)
// 	// 				// console.log($(that).data("handle"))
// 	// 				if (product.available == false) {
// 	// 					$(that).addClass("unavailable")
// 	// 				}
// 	// 			}).catch(error => console.error(error))
// 	// 	})
// 	// }
// })

$(document).ready(function () {
	$("#adult-popup [data-adult]").click(function () {
		$.fancybox.close()
	})
	$("#pdp-popup [data-pdp-popup]").click(function () {
		$.fancybox.close()
	})
	$("#disclaimer-popup [data-disclaimer]").click(function () {
		$.fancybox.close()
	})
    $("#custom-offer-cart-popup [data-custom-offer-cart-popup]").click(function () {
		$.fancybox.close()
	})
	$("#custom-offer-cart-popup [data-custom-offer-cart-popup-add]").click(function () {
		window.location.href='/cart/add?id=43363826499747&quantity=1';
	})
	// const countriesList = ['US']
	// $.get("https://www.cloudflare.com/cdn-cgi/trace", function(response) {
	//     const initialValue = {};
	//     const data_responsed = response.split("\n").reduce((obj, item) => {
	//         return {
	//         ...obj,
	//         [item.split('=')[0]]: item.split('=')[1],
	//         };
	//     }, initialValue);
	//     const who_is = data_responsed.loc

	//     if (who_is) {
	//         console.log("Your location:", who_is)

	//         if (who_is == "US") {
	//             const $notificationUS = $('.notification-us')

	//             setInterval(changetext, 5000);
	//             function changetext() {
	//                 const $spanActive = $($notificationUS.find("span.active"))
	//                 const $spanNoActive = $($notificationUS.find("span.no-active"))

	//                 $spanActive.fadeOut(function() {
	//                     $spanActive.removeClass("active").addClass("no-active")
	//                     $spanNoActive.fadeIn(function() {
	//                         $spanNoActive.addClass("active").removeClass("no-active")
	//                     })
	//                 })
	//             }
	//         }

	//         if(countriesList.includes(who_is)){
	//             $(`[data-location="${who_is}"]`).show()
	//         } else {
	//             $('[data-location="all"]').show()
	//         }

	//         $(".notification").css("visibility", "visible")
	//     }
	// },"text");

	$(".search-button").click(function () {
		if ($(window).width() >= 768) {
			$(this).prev().toggleClass("active")
			$(this).prev().find("input").focus()
		} else {
			$(".mobile-search-form").toggleClass("active")
			$(".mobile-search-form").find("input").focus()
		}
	})
	$(".mobile-search-form .close").click(function () {
		$(".mobile-search-form").toggleClass("active")
	})
	$("nav#menu").mmenu({
		offCanvas: {
			position: "left",
			zposition: "front",
		},
		navbars: [
			{
				position: "top",
				content: ["prev", "title", "close"],
			},
		],
	})

	AOS.init({
		easing: "ease-in-out-sine",
		duration: 500,
		delay: 300,
		once: true,
		disable: "mobile",
		offset: 30,
	})

	$(document).on("scroll", function () {
		AOS.refresh({
			disable: "mobile",
			delay: 200,
			duration: 200,
			once: true,
		})
	})

	// detect mobile
	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		$("body").addClass("mobile_device")
	}

	// calc dimensions
	//     $(".index-template-hero").css("padding-top", $("#header").outerHeight() + 45)
	//     $(".main__content").css("padding-top", $("#header").height() + 49)
	//   	$(".main__content").css("padding-top", 111)

	// pages/sliding-slack
	$(".faces-slider").slick({
		infinite: false,
		dots: false,
		arrows: true,
		fade: true,
		prevArrow: '<button type="button" class="slick-prev"><</button>',
		nextArrow: '<button type="button" class="slick-next">></button>',
	})

	$(".index-slider").slick({
		dots: false,
		arrows: true,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 4350,
		speed: 500,
		fade: true,
		cssEase: "ease",
		prevArrow: '<button type="button" class="slick-prev"><</button>',
		nextArrow: '<button type="button" class="slick-next">></button>',
	})

	$("#page-slider-1").slick({
		dots: false,
		arrows: false,
		infinite: true,
		autoplay: true,
		speed: 500,
		fade: true,
		cssEase: "ease",
	})

	$("#page-slider-2").slick({
		dots: false,
		arrows: false,
		infinite: true,
		autoplay: true,
		speed: 1000,
		cssEase: "ease",
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1023,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 639,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	})

	$(".slider-wrap-inner").slick({
		dots: true,
		infinite: false,
		speed: 300,
		slidesToShow: 3,
		arrows: false,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
					dots: true,
				},
			},
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	})

	$(".product-details-slider .slider-for").on("init", function (event, slick) {
		$(".image-zoom").zoom({
			magnify: 1.5,
			duration: 60,
			touch: false,
		})
	})
	$(".product-details-slider .slider-for").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: ".slider-nav",
		infinite: false,
	})
	$(".product-details-slider .slider-nav").slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		asNavFor: ".slider-for",
		dots: false,
		centerMode: false,
		focusOnSelect: true,
		arrows: true,
		infinite: false,
		prevArrow: '<button type="button" class="slick-prev"><</button>',
		nextArrow: '<button type="button" class="slick-next">></button>',
	})

	// main-page-media.liquid
	$(".slider-media").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		centerMode: false,
		focusOnSelect: true,
		arrows: true,
		prevArrow: '<button type="button" class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0224/6859/files/icon-top.svg" alt="arrow-prev" /></button>',
		nextArrow: '<button type="button" class="slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0224/6859/files/icon-top.svg" alt="arrow-next" /></button>',
		autoplay: false,
	})

	// matchHeight
	$(".product_entry figure").matchHeight()
	$(".product_entry header").matchHeight()

	jQuery(".back_to_top").click(function () {
		jQuery("html, body").animate({ scrollTop: "0" }, 1000)
	})

	if ($(".dropdown-heading")) {
		$(".dropdown-heading").click(function () {
			$(this).toggleClass("active")
			$(this).siblings(".dropdown-content").toggleClass("active")
		})
	}

	$("ul.accordion").accordion()
	// pages/jobs
	$("#accordion h3").click(function () {
		const $curAccordion = $(this).next()
		let isOpen = $curAccordion.hasClass("accordion-open")
		if (isOpen) {
			$curAccordion.fadeOut(200, function () {
				$curAccordion.removeClass("accordion-open")
			})
		} else {
			$curAccordion.fadeIn(200, function () {
				$curAccordion.addClass("accordion-open")
			})
		}
	})

	$(".input-number-wrap .qty__adjust").on("click", function () {
		var $button = $(this)
		var oldValue = $button.parent(".input-number-wrap").find("input").val()

		if ($button.hasClass("qty__adjust--plus")) {
			var newVal = parseFloat(oldValue) + 1
		} else {
			// Don't allow decrementing below zero
			if (oldValue > 0) {
				var newVal = parseFloat(oldValue) - 1
			} else {
				newVal = 0
			}
		}

		$button.parent().find("input").val(newVal)
	})

	// collection.stack - isotope filter

	if ($(".products-isotope").length > 0) {
		const $grid = $(".products-isotope").isotope({
			itemSelector: ".col",
			layoutMode: "fitRows",
		})

		$(".products-isotope")
			.imagesLoaded()
			.progress(function () {
				$(".products-isotope").isotope("layout")
			})

		$(".button-group-isotope .button-isotope").click(function () {
			const filterValue = $(this).attr("data-filter")
			$(".button-group-isotope .button-isotope").removeClass("active")
			$(this).addClass("active")
			$(".products-isotope").isotope({ filter: filterValue })
			$(".button-isotope-clear").fadeIn()
		})

		$(".button-group-isotope .button-isotope-clear").click(function () {
			const filterValue = $(this).attr("data-filter")
			$(".products-isotope").isotope({ filter: filterValue })
			$(".button-group-isotope .button-isotope").removeClass("active")
			$(this).fadeOut()
		})
		const hashFilterParser = () => {
			let hashClass = window.location.hash.replace("#", ".")
			if (hashClass.includes(".heading-")) {
				$(".button-isotope-clear").fadeIn()
				$(".products-isotope").isotope({ filter: hashClass })
				$(`.button-group-isotope .button-isotope[data-filter="${hashClass}"]`).addClass("active")
			}
		}
		hashFilterParser()
		$(window).on("hashchange", function () {
			$(".button-group-isotope .button-isotope").removeClass("active")
			hashFilterParser()
		})
	}

	// cart

	$(document).on("click", "#ajax-add-to-cart", async function () {
		const product = {
			id: $("#ajax-add-to-cart").data("variant-id"),
			quantity: $("#ajax-add-to-cart").data("quantity"),
		}
		await addToCart(product)
	})

	$(".product-ajax-form").submit(function (e) {
		e.preventDefault()
		addToCart_form($(this))
	})

	$(".cart-ajax-update").change(function () {
		updateQuantity($(this))
	})

	$(".cart-ajax-delete").click(function () {
		updateQuantity($(this))
	})

	$(".cart-ajax-reload").click(function (e) {
		e.preventDefault()
		reloadCart()
	})

	$(".cart-button").mouseenter(function () {
		openCart()
	})

	$(".cart-ajax").mouseleave(function () {
		closeCart()
	})

	async function setFreeShipping() {
		let request = await fetch("/")
		let html = await request.text()
		$("#h_top_bar").html($(html).find("#h_top_bar").html())
	}

	async function openCart() {
		$(".cart-ajax").addClass("active").fadeIn(100)
		$(".cart-ajax .content-loader").html(`<div class="ring-loader"><div></div><div></div><div></div><div></div></div>`)
		$(".cart-ajax .content-loader").load("/cart?view=ajax", function () {
			let cartJson = JSON.parse($(".content-loader").find("#cartJSON").text())
			$(".cart-button span").text(cartJson.item_count)

			$(".cart-ajax-delete").click(function () {
				// For cart.ajax template, if "true" = no reload page
				updateQuantity($(this), true)
			})

			$(".cart-close").click(function (e) {
				e.preventDefault()
				closeCart()
			})
		})
	}

	function closeCart() {
		$(".cart-ajax").removeClass("active").fadeOut(100)
	}

	async function addToCart(product) {
		try {
			const response = await fetch("/cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(product),
			})
			if (!response.ok) {
				throw response
			}
			console.log("Successed!")
			nativeToast({
				message: "Added!",
				timeout: 5000,
				rounded: true,
				position: "south",
				closeOnClick: true,
				type: "success",
			})

			setTimeout(reloadCart, 1500)

			return await response.json()
		} catch (e) {
			console.error("Add to cart failed", e)
			if (e.status == 422) {
				nativeToast({
					message: "Out Of Stock!",
					timeout: 5000,
					rounded: true,
					position: "south",
					closeOnClick: true,
					type: "error",
				})
			} else {
				nativeToast({
					message: "Add to cart failed!",
					timeout: 5000,
					rounded: true,
					position: "south",
					closeOnClick: true,
					type: "error",
				})
			}
		}
	}

	function addToCart_form($form) {
		$.ajax({
			url: "/cart/add.js",
			type: "POST",
			data: $form.serialize(),
			dataType: "json",
			contentType: "application/x-www-form-urlencoded",
			success: function () {
				console.log("Successed!")
				openCart()
				setFreeShipping()
				nativeToast({
					message: "Added!",
					timeout: 5000,
					rounded: true,
					position: "south",
					closeOnClick: true,
					type: "success",
				})
			},
			error: function (e) {
				console.log("Add to cart failed ", e)
				let error = JSON.parse(e.responseText)
				if (error.status == 422) {
					nativeToast({
						message: "Out Of Stock!",
						timeout: 5000,
						rounded: true,
						position: "south",
						closeOnClick: true,
						type: "error",
					})
				}
			},
		})
	}

	function updateQuantity($item, isCartAjaxTemplate = false) {
		const quantity = $item.val()
		const key = $item.data("key")

		$.ajax({
			url: "/cart/change.js",
			type: "POST",
			data: JSON.stringify({ quantity: quantity, id: key }),
			dataType: "json",
			contentType: "application/json",
			success: function (data) {
				console.log("Successed!")
				setFreeShipping()
				if (quantity > 0) {
					let item_quantity = data.items.filter((i) => i.key == key)[0].quantity
					if (quantity != item_quantity) {
						nativeToast({
							message: "Out Of Stock!",
							timeout: 5000,
							rounded: true,
							position: "south",
							closeOnClick: true,
							type: "error",
						})
						$(`[data-key="${key}"]`).val(item_quantity)
					} else {
						nativeToast({
							message: "Quantity changed",
							timeout: 5000,
							rounded: true,
							position: "south",
							closeOnClick: true,
							type: "success",
						})
						reloadCart()
					}
				} else {
					nativeToast({
						message: "Removed",
						timeout: 5000,
						rounded: true,
						position: "south",
						closeOnClick: true,
						type: "success",
					})
					if (isCartAjaxTemplate) {
						openCart()
					} else {
						reloadCart()
					}
				}
			},
			error: function (e) {
				let error = JSON.parse(e.responseText)
				console.log(e)
				if (error.status == 422) {
					nativeToast({
						message: "Out Of Stock!",
						timeout: 5000,
						rounded: true,
						position: "south",
						closeOnClick: true,
						type: "error",
					})
				} else {
					nativeToast({
						message: "Cart page error!",
						timeout: 5000,
						rounded: true,
						position: "south",
						closeOnClick: true,
						type: "error",
					})
				}
			},
		})
	}

	function reloadCart() {
		document.location.reload()
	}

	// Smart Wishlist & Order Trackicg
	if (window.location.pathname.includes("/a/wishlist") || window.location.pathname.includes("/tools/track-your-order")) {
		console.log(`Opened ${window.location.pathname} page`)
		$("header#header").addClass("header-bg")
		if (window.location.pathname.includes("/tools/track-your-order")) {
			$.get("/pages/faq-test", function (data) {
				$(".packages24-tracking-page-wrapper .packages24-tracking-page-header").append("<h2>CUSTOMER CARE</h2>")

				$(".packages24-tracking-page-wrapper").append($(data).find(".content"))
				$(".packages24-tracking-page-wrapper .content").css({ marginTop: "40px" })
				$(".packages24-tracking-page-wrapper .content #accordion").css({ padding: "20px 0", borderBottom: "1px solid #eee" })
				$(".packages24-tracking-page-wrapper .content h3").css({ fontSize: "16px", cursor: "pointer", padding: "0", textTransform: "uppercase" })
				$(".packages24-tracking-page-wrapper .content h3 + div").css({ paddingTop: "10px" })
				$(".packages24-tracking-page-wrapper .content h3 + div p").css({ padding: "0" })
				$(".packages24-tracking-page-wrapper .content h3 + div a").css({ fontWeight: "bold" })
			})
		}
	}

	// Change carousel image when selecting another variant
	// Checking it the selec elemet exists -- only for multi-variant products
	if (document.querySelector(".product-details-wrap .selectWrapper")) {
		const variantSelect = document.querySelector(".product-details-wrap .selectWrapper")
		variantSelect.addEventListener("change", function (e) {
			e.preventDefault()

			// Get variant title from the select option
			let slideAlt = $(".selectWrapper option:selected").data("title")
			console.log("variant title", slideAlt)

			// Get images from thumbs carousel
			const thumbsArray = document.querySelectorAll(".product-details-slider .slider-nav .slick-slide img")

			// Loop through thumbsArray images and click if image.alt matches variant title
			thumbsArray.forEach((element) => {
				if (element.alt == slideAlt) {
					console.log("element", element)
					element.click()
				}
			})
		})
	}

	$("#delimiter").on("input change", (evt) => {
		const sliderPos = evt.target.value
		$(".foreground").css("width", `${sliderPos}%`)
		$(".delimiter-button").css("left", `calc(${sliderPos}% - 21px)`)
	})
})
